/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Details about the resource\'s sensitivity annotations.
*/
export class SensitivityAnnotationsDetails {
  /**
  * Whether the resource has sensitivity annotations detected.
  */
  'hasSensitivityAnnotations'?: boolean;
  /**
  * Whether the sensitivity annotations status has been manually overridden.
  */
  'isOverridden'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "hasSensitivityAnnotations",
      "baseName": "hasSensitivityAnnotations",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "isOverridden",
      "baseName": "isOverridden",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SensitivityAnnotationsDetails.attributeTypeMap;
  }

  public constructor() {
  }
}

